import { TooltipPill } from '@/components/ui/tooltip-pill';
import { findTimeZoneByValue } from '@/lib/time-zones';
import TimezoneIcon from '@/routes/_layout/my-availability/assets/timezone-icon.svg';

interface TimeZonePillProps {
  timeZone: string;
  dataTestId?: string;
}

export function TimeZonePill({ timeZone, dataTestId }: TimeZonePillProps) {
  const { standardAbbr } = findTimeZoneByValue(timeZone) || {};

  return (
    <TooltipPill labelTooltip="To change your local time zone, please visit your Account.">
      <div className="flex items-center gap-1" data-testid={dataTestId}>
        <img src={TimezoneIcon} alt="Time Zone" />
        <span className="text-xs md:text-base text-[#404040] font-medium">
          {timeZone}
          {standardAbbr && `(${standardAbbr})`}
        </span>
      </div>
    </TooltipPill>
  );
}
